if (!Enum) {
    var Enum = {};
}

Enum.STATE_OF_HEALTH_SIMULATION_ICF_ENTRY_SIMULATION_RESULT = {
    WORSE: 'WORSE',
    SAME: 'SAME',
    BETTER: 'BETTER'
};

Object.freeze(Enum.STATE_OF_HEALTH_SIMULATION_ICF_ENTRY_SIMULATION_RESULT);